export default __webpack_public_path__ + "static/media/el24.35d5ab8c.svg";